import React from 'react';
import times from 'lodash/times';
import { HtmlTable } from '../../../CommonComponents/OPL/HtmlTable/HtmlTable';
import { Shimmer } from '../../../CommonComponents/OPL/Shimmer/Shimmer';

const OtherAssetsTableLoading = () => {
  return (
    <table>
      <colgroup>
        <col width="50%" />
        <col width="50%" />
      </colgroup>

      <caption>
        <Shimmer width={100} height={24} />
      </caption>

      <thead>
        <tr>
          {times(5).map(key => (
            <th key={key}>&nbsp;</th>
          ))}
        </tr>
      </thead>

      <tbody>
        <tr>
          <td>
            <Shimmer width={100} height={20} my="4" />
          </td>
          <td>
            <Shimmer width={90} height={20} />
          </td>
          <td>
            <Shimmer width={90} height={20} />
          </td>
          <td>
            <Shimmer width={34} height={20} />
          </td>
          <td>
            <Shimmer width={56} height={20} />
          </td>
        </tr>
      </tbody>
    </table>
  );
};

interface Props {
  isWorkflow: boolean;
}

export const ProfileTablesLoading = ({ isWorkflow }: Props) => {
  return (
    <>
      {times(4).map(key => (
        <HtmlTable
          key={key}
          variant={isWorkflow ? 'bordered' : undefined}
          columnSpacing="large"
          mb="32"
        >
          <OtherAssetsTableLoading />
        </HtmlTable>
      ))}
    </>
  );
};
